import { useEffect, useRef, useState, useCallback } from 'react';
import { gateway, type MessageHandler } from '../gateway/connection';
import type { ConnectionStatus, UserRole } from '../types/gateway';

export function useGateway(userRole: UserRole, userId: string) {
  const [status, setStatus] = useState<ConnectionStatus>('disconnected');
  const handlersRef = useRef<Set<MessageHandler>>(new Set());

  useEffect(() => {
    const unsubStatus = gateway.onStatusChange(setStatus);
    gateway.connect(userRole, userId);

    return () => {
      unsubStatus();
    };
  }, [userRole, userId]);

  const send = useCallback((data: unknown) => {
    gateway.send(data);
  }, []);

  const onMessage = useCallback((handler: MessageHandler) => {
    handlersRef.current.add(handler);
    const unsub = gateway.onMessage(handler);
    return () => {
      handlersRef.current.delete(handler);
      unsub();
    };
  }, []);

  return { status, send, onMessage };
}
